import { Tag } from "../models/tag";

export let MasterData = {
  data: {},
  // before_meeting_types: string[];
  // body_types: string[];
  // brother_types: string[];
  // business_types: string[];
  // cigarette_types: string[];
  // drinking_types: string[];
  // education_types: string[];
  // hometowns: string[];
  // income_types: string[];
  // living_together_types: string[];
  // marital_types: string[];
  // purpose_types: string[];
  // residence_locations: string[];
  // selectable_tags: string[];
  // sister_types: string[];

  getData(): any {
    return this.data;
  },

  setData(data: any): void {
    this.data = data;
  },

  getAllSelectableTags(): Tag[] {
    const selectableTags: Tag[] = [];
    for (const i in this.data.selectable_tags) {
      // status:0 が利用可、 status:1が利用不可
      if (this.data.selectable_tags[i].status === 0) {
        selectableTags.push(this.data.selectable_tags[i]);
      }
    }
    return selectableTags;
  },

  getTagByTagId(tagId: number): Tag {
    return this.getAllSelectableTags().find((tag) => {
      return tag.id === tagId;
    });
  },

  getBasicInformationColumnArray(): any {
    return [
      { name: "height", displayName: "身長", category: "appearance" },
      {
        name: "looks",
        displayName: "雰囲気",
        category: "appearance",
        onlyFemale: true,
      },
      {
        name: "personality",
        displayName: "性格・タイプ",
        category: "appearance",
        onlyFemale: true,
      },
      { name: "residence_location", displayName: "居住地", category: "base" },
      { name: "hometown", displayName: "出身地", category: "base" },
      {
        name: "purpose",
        displayName: "デートでしたいこと",
        category: "dating",
      },
      {
        name: "before_meeting",
        displayName: "出会うまでの希望",
        category: "dating",
      },
      { name: "body_type", displayName: "スタイル", category: "appearance" },
      // {
      //   name: "bust_type",
      //   displayName: "バスト",
      //   category: "appearance",
      //   onlyFemale: true,
      // },
      { name: "education_type", displayName: "学歴", category: "work" },
      {
        name: "income_type",
        displayName: "年収",
        category: "work",
        onlyMale: true,
      },
      {
        name: "asset_type",
        displayName: "資産",
        category: "work",
        onlyMale: true,
      },
      { name: "business_type", displayName: "お仕事", category: "work" },
      { name: "drinking_type", displayName: "お酒", category: "lifestyle" },
      { name: "cigarette_type", displayName: "タバコ", category: "lifestyle" },
      {
        name: "holiday_type",
        displayName: "休日",
        category: "work",
      },
      {
        name: "register_reason",
        displayName: "登録した理由",
        category: "dating",
        onlyFemale: true,
      },
      {
        name: "desired_dating_place",
        displayName: "初回デートで行きたい場所",
        input: true,
        category: "dating",
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/models/master-data.ts